import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { manualQuoteType } from "../../../shared/manual-quote-type/manual-quote-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-manual-quote-type-select",
  templateUrl: "./manual-quote-type-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class ManualQuoteTypeSelectComponent implements OnInit {
  public readonly manualQuoteTypeChange = output();
  @Input() public manualQuoteType = "Select type";
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public manualQuoteTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildManualQuoteTypeList();
  }

  public onManualQuoteTypeChange(event) {
    this.manualQuoteTypeChange.emit(event.value);
  }

  private buildManualQuoteTypeList() {
    this.manualQuoteTypeList.push({
      label: "Manual",
      value: null,
    });
    Object.keys(manualQuoteType).map((key) => {
      this.manualQuoteTypeList.push({
        label: manualQuoteType[key],
        value: key,
      });
    });
  }
}
